import SectionHeader from "./SectionHeader";

const steps = [
  { n: "01", t: "Plan", d: "Pick a subject and a goal. The AI maps out a path through curated videos to reach it.", icon: "🎯" },
  { n: "02", t: "Learn", d: "Your child watches, answers questions, and gets AI summaries of each lesson.", icon: "📺" },
  { n: "03", t: "Track", d: "You get a daily email digest and an in-app dashboard. Conversation-ready.", icon: "📬" },
];

function HowItWorksSection() {
  return (
    <section data-ga-section="how_it_works" className="bg-pastelyellow-light py-20">
      <div className="max-w-screen-lg mx-auto px-6">
        <SectionHeader eyebrow="How it works" title="Three steps. No spreadsheets." />
        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((s) => (
            <div key={s.n} className="relative">
              <div className="bg-white rounded-3xl p-7 iv1-soft-shadow h-full flex flex-col gap-4">
                <div className="flex items-start justify-between">
                  <div className="w-12 h-12 rounded-2xl bg-pastelyellow flex items-center justify-center text-2xl">
                    {s.icon}
                  </div>
                  <div className="font-mono text-[11px] text-darkrock/40 tracking-wider">{s.n}</div>
                </div>
                <h3 className="iv1-font-display font-bold text-darkrock text-2xl">{s.t}</h3>
                <div className="text-darkrock/70 text-[14px] leading-relaxed">{s.d}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowItWorksSection;
